<template>
	<div
		class="groupFields"
		:class="[customClass, {'right': isRight, 'center': isCenter}]"
		:style="{ alignItems, justifyContent, flex, width, margin }"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "Row",
	props: {
		isCenter: Boolean,
		isRight: Boolean,
		alignItems: String,
		width: String,
		flex: String,
		justifyContent: String,
		margin: {
			type: String,
			default: () => '0 0 10px 0'
		},
		customClass: String
	}
};
</script>

<style scoped lang="scss">
.groupFields {
	display: flex;
	width: 100%;

	&.center {
		justify-content: center;
	}

	&.right {
		justify-content: flex-end;
	}
}
</style>
